module.exports = __webpack_public_path__ + "a768e7de/img/comments-icon.fdec7fdb.svg";